import { ROUTES } from '../../../../Routes';
import * as React from 'react';
import { USERNAME } from 'ts/constants/UrlParams';
import { ErrorFlow } from '../../pages/error/ErrorFlow';
import PageConfig from '../../../../services/userflow/PageConfig';
import { LogInNowSection } from '../../pages/enter-username/sub-components/LoginSection';
import { CaptchaSection } from '../../pages/enter-username/sub-components/CaptchaSection';
import { AuthCard } from '../../../../components/Card';
import { EnterUsernameForm } from '../../pages/enter-username/EnterUsernameForm';
import RegisterClipboard from 'images/register_clipboard.svg';
import { navigateToErrorPageFromRegister } from '../../pages/error/ErrorNavigation';
import { History } from 'history';
import { Page } from '../../../../components/Page';

interface RegisterEnterUsernamePageProps {
  history: History;
  location: Location;
}

const nextAction = (history: any) => (urlParams: string) => {
  history.push(`${ROUTES.REGISTER_ONE_TIME_CODE}?${urlParams}`);
};

const errorAction = (history: any) => (username: string) => {
  history.push({
    pathname: ROUTES.MANUAL_REG_FIND_CUSTOMER,
    search: `?${USERNAME}=${username}`,
  });
};

const pageConfig = {
  errorType: ErrorFlow.register,
  startRoute: ROUTES.REGISTER_ENTER_USERNAME,
  analytics: { pageName: 'register', taskName: 'my-account-registration' },
} as PageConfig;

const RegisterEnterUsernamePage: React.FC<RegisterEnterUsernamePageProps> = ({
  history,
  location,
}) => (
  <Page>
    <AuthCard image={RegisterClipboard}>
      <>
        <EnterUsernameForm
          history={history}
          location={location}
          nextAction={nextAction(history)}
          config={pageConfig}
          customErrorAction={errorAction(history)}
          navigateToErrorPage={navigateToErrorPageFromRegister(history)}
          infoText="Enter the email address linked to your account"
        />
        <LogInNowSection />
        <CaptchaSection />
      </>
    </AuthCard>
  </Page>
);

export { RegisterEnterUsernamePage };
